import type { ContactStatus, EventType, SpeciesBucket } from '../types/contact'

export const SPECIES_LABELS: Record<SpeciesBucket, string> = {
  backyard_poultry: 'Backyard poultry',
  commercial_poultry: 'Commercial poultry',
  wild_waterbird: 'Wild waterbird',
  wild_seabird: 'Wild seabird',
  raptor: 'Raptor',
  marine_mammal: 'Marine mammal',
  other: 'Other',
}

export const ALL_SPECIES_BUCKETS = Object.keys(SPECIES_LABELS) as SpeciesBucket[]

export const EVENT_TYPE_LABELS: Record<EventType, string> = {
  mass_mortality: 'Mass mortality (many dead at once)',
  sick_birds: 'Sick/lethargic birds',
  unusual_die_off: 'Unusual die-off over a few days',
  single_dead_bird: 'Single dead bird',
  other: 'Other',
}

export const ALL_EVENT_TYPES = Object.keys(EVENT_TYPE_LABELS) as EventType[]

// Ordinal — index doubles as the "min_status" rank used by ConfidenceFilter.
export const CONTACT_STATUSES: ContactStatus[] = [
  'unconfirmed',
  'corroborated',
  'high_confidence',
  'officially_declared',
]

export const STATUS_LABELS: Record<ContactStatus, string> = {
  unconfirmed: 'Unconfirmed',
  corroborated: 'Corroborated',
  high_confidence: 'High confidence',
  officially_declared: 'Officially declared',
}

// Substring-matched against reports.source_agency (the raw CAP-alert-platform alert `sender`
// domain) — mirrors CAP-alert-platform's own _BIOSECURITY_SENDERS matching convention, so a
// new upstream source added there needs a label added here, not a schema change on either side.
const OFFICIAL_SOURCE_LABELS: [substring: string, label: string][] = [
  ['empres-i.apps.fao.org', 'FAO EMPRES-i+'],
  ['services.arcgis.com/nxaios6bslpqjamb', 'WA DPIRD'],
  ['pirsa.geohub.sa.gov.au', 'SA PIRSA'],
]

export function officialSourceLabel(sourceAgency: string | null): string | null {
  if (!sourceAgency) return null
  const lower = sourceAgency.toLowerCase()
  const match = OFFICIAL_SOURCE_LABELS.find(([substr]) => lower.includes(substr))
  return match ? match[1] : 'Official source'
}
